

import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import { Badge } from '@/components/ui/badge';

interface Transaction {
  id: string;
  timestamp: string;
  model: string;
  cost: number;
  tokens: number;
  user_id?: string;
  email?: string;
  feature: string;
}

interface AICostTransactionsProps {
  transactions: Transaction[];
}

export function AICostTransactions({ transactions }: AICostTransactionsProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Recent AI Transactions</CardTitle>
        <CardDescription>
          Detailed breakdown of recent AI interactions
        </CardDescription>
      </CardHeader>
      <CardContent>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Date</TableHead>
              <TableHead>User</TableHead>
              <TableHead>Feature</TableHead>
              <TableHead>Model</TableHead>
              <TableHead className="text-right">Tokens</TableHead>
              <TableHead className="text-right">Cost</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {transactions.map((transaction) => (
              <TableRow key={transaction.id}>
                <TableCell>
                  {new Date(transaction.timestamp).toLocaleDateString()}
                </TableCell>
                <TableCell>{transaction.email || 'Unknown'}</TableCell>
                <TableCell>
                  <Badge variant="outline">{transaction.feature}</Badge>
                </TableCell>
                <TableCell>{transaction.model}</TableCell>
                <TableCell className="text-right">{transaction.tokens.toLocaleString()}</TableCell>
                <TableCell className="text-right font-medium">
                  ${transaction.cost.toFixed(4)}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
}
